module.exports = __webpack_public_path__ + "static/media/badge.efae508a.svg";